<template>
  <div class="index" v-cloak>
    <div class="index-bg" :style="{backgroundImage:`url(${require('@assets/images/dywfl/background.jpg')})`}"></div>
    <div class="index-bg" :style="{background:`#fff`,opacity:'.7'}"></div>
    <div class="list-title">{{cate_info.title}}</div>
    <div class="list">
      <div class="news-item" v-for="(item,index) in articleList" @click="goDetail(item.id)">
        <div class="news-msg">
          <div class="item-title">{{item.title}}</div>
          <div class="item-intro">{{item.synopsis}}</div>
          <div class="item-tag">{{cate_info.title}} {{item.add_time}}</div>
        </div>
        <img :src="item.image_input[0]" alt="">
      </div>
    </div>
    <div class="page-content">
        <div class="iconfont icon-xiangzuo" @click="prePage"></div>
        <div class="page_number"><span style="color:#ff0000">{{page}}</span><span style="margin:0 .2rem">/</span>{{page_count}}</div>
        <div class="iconfont icon-xiangyou" @click="nextPage"></div>
    </div>
    <div class="index-botom" style="height: 1rem"></div>
  </div>
</template>

<script>
import {getArticleList,getCate} from "@api/public";

import cookie from "@utils/store/cookie";

export default {
  name: "CateList",
  components: {
  },
  props: {},
  data: function () {
    return {
      cid: 0, //分类id
      cate_list: [], //分类列表
      history_pid:[],//分类历史
      page:1,
      page_count:1,
      limit:10,
      articleList:[],
      cate_info:"",
    };
  },
  mounted: function () {
    let that = this;
    that.cid = that.$route.query.id;
    that.getArticleList();
    that.getCate();
  },
  methods: {
    // test:function(){
    //   console.log('...');
    // },
    //获取文章列表
    getArticleList:function(){
      let that = this;
      let q = {
        page: that.page,
        limit: that.limit
      };
      getArticleList(q, that.cid).then(res => {
        that.loading = false;
        if(q.page=1&&res.data.list.length<=0){
          that.$dialog.toast({ mes: "暂无文章" });
          setTimeout(() => {
            this.$router.push({ path: "/"});
          },2000);
        }
        that.articleList = res.data.list;
        that.page_count = Math.ceil(res.data.count/that.limit);
      });
    },
    // 获取类型详情
    getCate:function(){
      let that = this;
      getCate(that.cid).then(res=>{
        that.cate_info = res.data
      })
    },
    //上一页
    prePage:function(){
      let that = this;
      let page = that.page;
      page -= 1;
      page = page>=1?page:1;
      that.page = page;
      that.getArticleList();
    },
    nextPage:function(){
      let that = this;
      let page = that.page;
      let page_count = that.page_count;
      page += 1;
      page = page<=page_count?page:page_count;
      that.page = page;
      that.getArticleList();
    },
    goDetail:function(id){
      console.log(id);
      this.$router.push({ path: "/news_detail/"+id});
    },
  },
};
</script>
<style scoped>
.index-bg{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
}
.list-title{
  position: relative;
  padding: .2rem;
  padding-left: .6rem;
  border-bottom: 1px solid #F3F3F3;
  font-size: .32rem;
}
.list-title::after{
  content: "";
  display: block;
  width: .05rem;
  height: .32rem;
  background: #F23030;
  position: absolute;
  left: .3rem;
  top: 50%;
  transform: translate(-50%,-50%);
}
.news-item{
  display: flex;
  padding: .3rem;
}
.news-item~.news-item{
  border-top: 1px solid #f0f0f0;
}
.news-item img{
  width: 1.86rem;
  height: 1.4rem;
  object-fit: contain;
  flex-shrink: 0;
}
.item-title{
  font-size: .32rem;
}
.item-intro{
  font-size: .28rem;
  color: #999;
  margin-top: .2rem;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:2;
  word-break:break-all;
  -webkit-box-orient:vertical;
}
.item-tag{
  font-size: .24rem;
  color: #999;
  margin-top: .2rem;
}
.news-msg{
  flex: 1;
}
.page-content{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .2rem 0;
  position: fixed;
  bottom: 1rem;
  width: 100%;
  left: 0;
}
.page-content .iconfont{
  font-size: .24rem;
  margin: 0 .4rem;
}
</style>
